/**
 * Light formatting for request activity text (system + user).
 * Escapes HTML first, then applies **bold**, `code`, and links.
 */

function escapeHtml(text) {
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

const SAFE_URL = /^(https?:\/\/|\/ai-garage\/)/i;

function anchor(href, label) {
  if (!SAFE_URL.test(href)) return escapeHtml(label);
  const external = /^https?:/i.test(href);
  const rel = external ? ' target="_blank" rel="noopener noreferrer"' : '';
  return `<a href="${href}" class="garage-comment-link"${rel}>${label}</a>`;
}

/**
 * @param {string} text
 * @returns {string} Safe HTML string
 */
export function formatCommentHtml(text) {
  if (!text) return '';

  let html = escapeHtml(text);

  // **bold**
  html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

  // `inline code`
  html = html.replace(/`([^`]+)`/g, '<code>$1</code>');

  // [label](url) — written by the route-to-IT and DOT escalation actions
  html = html.replace(
    /\[([^\]]+)\]\((https?:\/\/[^\s)]+|\/ai-garage\/[^\s)]+)\)/g,
    (_match, label, href) => anchor(href, label)
  );

  // Bare URLs, skipping any already turned into an anchor above
  html = html.replace(
    /(^|[\s(])(https?:\/\/[^\s<)"']+)/g,
    (_match, prefix, href) => `${prefix}${anchor(href, href)}`
  );

  // Relative AI Garage paths (after escape, paths are unchanged)
  html = html.replace(
    /(^|[\s(])(\/ai-garage\/[^\s<)&'"]+)/g,
    (_match, prefix, href) => `${prefix}${anchor(href, href)}`
  );

  // Newlines
  html = html.replace(/\n/g, '<br />');

  return html;
}
